import React, { useCallback } from 'react';
import WavetrakLink from 'components/WavetrakLink';
import { Camera } from 'types/camera';
import { SpotDetails } from 'types/spot';
import { trackEvent } from '@surfline/web-common';

interface CamHostAdProps {
  camera: Camera;
  isMultiCam?: boolean;
  spot?: SpotDetails;
  className?: string;
}

const CamHostAd = ({ camera, isMultiCam = false, spot, className }: CamHostAdProps) => {
  const handleCamHostLinkClick = useCallback(() => {
    trackEvent('Clicked Link', {
      camId: camera?._id,
      camName: camera?.alias,
      isMultiCam,
      linkName: camera?.host?.name,
      linkUrl: camera?.host?.url,
      spotName: spot?.name,
      spotId: spot?._id,
    });
  }, [camera, isMultiCam, spot]);
  if (
    !camera.host?.camLinkEnabled ||
    (!camera.host?.name?.length && !camera.host?.camLinkText?.length)
  )
    return null;

  const camLinkText = camera.host.camLinkText || `Camera hosted by ${camera.host.name}`;

  if (!camera.host?.url) {
    return (
      <div key={`cam-host-${camera._id}`}>
        <span>{camLinkText}</span>
      </div>
    );
  }

  return (
    <div key={`cam-host-${camera._id}`}>
      <WavetrakLink
        isExternal
        target="_blank"
        href={camera.host.url}
        onClick={handleCamHostLinkClick}
        className={className}
      >
        {camLinkText}
      </WavetrakLink>
    </div>
  );
};

export default CamHostAd;
